import { Link, Typography } from '@mui/material';
import { AnnouncementBanner } from '@/shared/ui';

const dialogContent = (
  <>
    <Typography variant="body2" paragraph>
      We are going to update our Privacy Policy, Data Processing Agreement, and
      Terms of Service in connection with the upcoming release of AI/MCP
      integrations. These updates clarify how customer-configured AI
      integrations may work, what data may be made available, and the
      responsibilities of Customers when enabling such integrations.
    </Typography>
    <Typography variant="body2" paragraph>
      The updated documents will be available here:
      <br />
      &ndash;{' '}
      <Link
        href="https://www.campaignswell.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </Link>
      <br />
      &ndash;{' '}
      <Link
        href="https://www.campaignswell.com/dpa"
        target="_blank"
        rel="noopener noreferrer"
      >
        Data Processing Agreement
      </Link>
      <br />
      &ndash;{' '}
      <Link
        href="https://www.campaignswell.com/terms"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Service
      </Link>
    </Typography>
    <Typography variant="body2" paragraph>
      The changes will take effect on May 19, 2026.
    </Typography>
    <Typography variant="body2">
      If you have any questions about our upcoming updates, please do not
      hesitate to email us at{' '}
      <Link href="mailto:support@campaignswell.com">
        support@campaignswell.com
      </Link>{' '}
      or contact your CSM.
    </Typography>
  </>
);

export function LegalUpdateBanner() {
  return (
    <AnnouncementBanner
      storageKey="cw-legal-update-2026-05-dismissed"
      bannerText="We are going to update our Privacy Policy, DPA, and Terms of Service."
      dialogTitle="Upcoming update to our Privacy Policy, DPA, and Terms of Service"
      dialogContent={dialogContent}
    />
  );
}
